export function getFlatMembers (episodes) {
        return  episodes.filter(({ hidden }) => !hidden).reduce((episodeAccum, currentEpisode) => episodeAccum
                .concat(currentEpisode.groups.reduce((groupAccum, currentGroup) => groupAccum
                        .concat(currentGroup.members.map(({ member }) => member))
                , []))
        , [])
    .filter((member, index, all) => all.findIndex(({ id }) => id === member.id) === index && member.allowQuestions && !member.hide);
}